module.exports = __webpack_public_path__ + "public/img/img_02.433354f4.png";